import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import Layout from "../../components/layout/Layout";
import { APIURL } from "../../redux/action/config";
import { Formik } from "formik";
import { useParams, useNavigate } from "react-router-dom";
import { ValidationOrder } from "../../utills/Validation";
import axios from "axios";
import { toast } from "react-toastify";
import { formatPhoneNumber } from "../../utils/phone";

const paymentOptions = [
  { title: "Cash", value: "cash" },
  { title: "Online (Debit/Credit Card)", value: "online" },
  { title: "Bank Transfer", value: "bank-transfer" },
];
// Utility function to format phone number using libphonenumber-js
// (Imported from utils/phone.js)
const EditInvoice = () => {
  const { id } = useParams(); // Get the invoice ID from the URL
  const navigate = useNavigate();
  const [invoiceData, setInvoiceData] = useState(null);
  const [orderDetails, setOrderDetails] = useState([
    { item: "", quantity: "", price: "" },
  ]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [transCh, setTransCh] = useState(0);
  const [tipAmount, setTipAmount] = useState(0);
  const [totalItem, setTotalItem] = useState(0);
  const [totalItemAmt, setTotalItemAmt] = useState(0);

  // Fetch the invoice data when the component mounts
  const fetchInvoice = async () => {
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const res = await axios.get(`${APIURL}/api/v1/customOrder/${id}`, config);
      const data = res?.data?.data?.customOrder;
      setInvoiceData(data);
      setOrderDetails(data?.order || [{ item: "", quantity: "", price: "" }]);
      setTransCh(data?.charges || 0);
      setTipAmount(data?.tipAmount || 0);
      calculateTotalAmount(data?.order || [], data?.charges || 0, data?.tipAmount || 0);
      calculateTotalQty(data?.order || []);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  useEffect(() => {
    fetchInvoice();
  }, [id]);

  // Calculate total amount
  const calculateTotalAmount = (orderDetails, transactionCharges, tip = tipAmount) => {
    const subtotal = orderDetails.reduce((acc, curr) => {
      return (
        acc + (parseFloat(curr.quantity) || 0) * (parseFloat(curr.price) || 0)
      );
    }, 0);
    setTotalItemAmt(subtotal);
    setTotalAmount(
      subtotal +
        (subtotal * (parseFloat(transactionCharges) || 0)) / 100 +
        (parseFloat(tip) || 0)
    );
  };

  // Calculate total quantity
  const calculateTotalQty = (orderDetails) => {
    const subtotal = orderDetails.reduce(
      (acc, curr) => acc + (parseInt(curr.quantity) || 0),
      0
    );
    setTotalItem(subtotal);
  };

  useEffect(() => {
    calculateTotalAmount(orderDetails, transCh, tipAmount);
    calculateTotalQty(orderDetails);
  }, [orderDetails, transCh, tipAmount]);

  const addRow = () => {
    setOrderDetails([...orderDetails, { item: "", quantity: "", price: "" }]);
  };

  const removeRow = (index) => {
    setOrderDetails(orderDetails.filter((_, i) => i !== index));
  };

  // Update the invoice
  const updateInvoice = async (data) => {
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    const body = JSON.stringify(data);
    try {
      const response = await axios.put(
        `${APIURL}/api/v1/customOrder/${id}`,
        body,
        config
      );
      toast.success("Invoice updated successfully!");
      setTimeout(() => {
        navigate("/invoice-list");
      }, 1000);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };

  if (!invoiceData) {
    return <div>Loading...</div>;
  }

  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />
      <Layout title="Edit Invoice" page="invoice">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            <div className="row">
              <div className="col-xl-8 offset-xl-2">
                <div className="card card-flush h-lg-100">
                  <div className="card-header pt-7">
                    <div className="card-title">
                      <h2>Edit Invoice No. {invoiceData?.orderNo}</h2>
                    </div>
                  </div>
                  <div className="card-body pt-5">
                    <Formik
                      initialValues={{
                        date: invoiceData?.date || "",
                        name: invoiceData?.name || "",
                        business: invoiceData?.business || "",
                        email: invoiceData?.email || "",
                        phone: invoiceData?.phone || "",
                        address: invoiceData?.address || "Nassau, Bahamas",
                        transationCharges: invoiceData?.charges || "",
                        tipAmount: invoiceData?.tipAmount || "",
                        notes: invoiceData?.notes || "",
                        disclaimer: invoiceData?.disclaimer || "Cancellation policy:\nIf you cancel a dispatched roadside service more than 15 minutes after dispatch but before a tow or service truck arrives (while en-route) there will be a $25 non-refundable dispatch fee.",
                        paymentMethod: invoiceData?.paymentMethod || "",
                        technician: invoiceData?.technician || "",
                        isPaid: invoiceData?.isPaid || false,
                        receiptNumber: invoiceData?.receiptNumber || "",
                      }}
                      validationSchema={ValidationOrder}
                      onSubmit={(values, { setSubmitting }) => {
                        const data = {
                          orderNo: invoiceData?.orderNo,
                          date: values?.date,
                          name: values?.name,
                          business: values?.business,
                          address: values?.address,
                          email: values?.email,
                          phone: values?.phone,
                          order: orderDetails,
                          charges: values?.transationCharges,
                          tipAmount: values?.tipAmount || 0,
                          total: totalAmount,
                          notes: values?.notes,
                          disclaimer: values?.disclaimer,
                          paymentMethod: values?.paymentMethod,
                          technician: values?.technician,
                          isPaid: values?.isPaid,
                          receiptNumber: values?.receiptNumber,
                        };
                        updateInvoice(data);
                        setSubmitting(false);
                      }}
                    >
                      {({
                        values,
                        handleBlur,
                        handleChange,
                        handleSubmit,
                        setFieldValue,
                        errors,
                        touched,
                      }) => (
                        <form className="form" onSubmit={handleSubmit}>
                          <div className="row row-cols-1 row-cols-sm-2 rol-cols-md-1 row-cols-lg-2">
                            <div className="col">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  <span className="required">Date & Time</span>
                                </label>
                                <input
                                  type="datetime-local"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="date"
                                  id="date"
                                  value={values.date}
                                  className="form-control form-control-solid b-1"
                                />
                                {errors.date && touched.date ? (
                                  <div className="text-danger mt-2">
                                    {errors.date}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <h3 className="required my-5">Customer Details</h3>
                          <div className="row row-cols-1 row-cols-sm-2 rol-cols-md-1 row-cols-lg-2">
                            <div className="col">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  <span className="required">Full Name</span>
                                </label>
                                <input
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="name"
                                  id="name"
                                  value={values.name}
                                  className="form-control form-control-solid b-1"
                                />
                                {errors.name && touched.name ? (
                                  <div className="text-danger mt-2">
                                    {errors.name}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                            <div className="col">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  Business Name (if any)
                                </label>
                                <input
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="business"
                                  id="business"
                                  value={values.business}
                                  className="form-control form-control-solid b-1"
                                />
                                {errors.business && touched.business ? (
                                  <div className="text-danger mt-2">
                                    {errors.business}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="row row-cols-1 row-cols-sm-2 rol-cols-md-1 row-cols-lg-2">
                            <div className="col">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  <span className="required">Email</span>
                                </label>
                                <input
                                  type="text"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="email"
                                  id="email"
                                  value={values.email}
                                  placeholder="e.g. a@example.com, b@example.com"
                                  className="form-control form-control-solid b-1"
                                />
                                <div className="form-text">
                                  Separate multiple email addresses with a comma
                                </div>
                                {errors.email && touched.email ? (
                                  <div className="text-danger mt-2">
                                    {errors.email}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                            <div className="col">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  <span className="required">Phone</span>
                                </label>
                                <input
                                  type="text"
                                  onChange={(e) => {
                                    const rawValue = e.target.value;
                                    const formattedValue = formatPhoneNumber(rawValue);
                                    
                                    // Update Formik's state
                                    handleChange({
                                      target: {
                                        name: "phone",
                                        value: rawValue,
                                      },
                                    });
                                    // Update the input field to show the formatted value
                                    e.target.value = formattedValue;
                                  }}
                                  onBlur={handleBlur}
                                  name="phone"
                                  id="phone"
                                  value={
                                    values.phone
                                      ? formatPhoneNumber(values.phone)
                                      : ""
                                  }
                                  className="form-control form-control-solid b-1"
                                />
                                {errors.phone && touched.phone ? (
                                  <div className="text-danger mt-2">
                                    {errors.phone}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="row row-cols-1 row-cols-sm-1 rol-cols-md-1 row-cols-lg-1">
                            <div className="col">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  <span className="required">Address</span>
                                </label>
                                <div className="d-flex gap-4 mb-2">
                                  {["Nassau, Bahamas", "Eleuthera, Bahamas"].map((location) => (
                                    <div key={location} className="d-flex align-items-center gap-2">
                                      <input
                                        type="checkbox"
                                        id={`loc-${location}`}
                                        className="form-check-input"
                                        checked={values.address === location}
                                        onChange={() =>
                                          setFieldValue("address", values.address === location ? "" : location)
                                        }
                                      />
                                      <label htmlFor={`loc-${location}`} className="form-label mb-0 fw-normal cursor-pointer">
                                        {location}
                                      </label>
                                    </div>
                                  ))}
                                </div>
                                <textarea
                                  rows="2"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="address"
                                  id="address"
                                  className="form-control form-control-solid b-1"
                                  value={values.address}
                                  placeholder="Or type address manually"
                                ></textarea>
                                {errors.address && touched.address ? (
                                  <div className="text-danger mt-2">
                                    {errors.address}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <h3 className="required my-5">Order Details</h3>
                          <div className="row">
                            <div className="col-6">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  <span className="required">
                                    Item Particulars
                                  </span>
                                </label>
                              </div>
                            </div>
                            <div className="col-2">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  <span className="required">Quantity</span>
                                </label>
                              </div>
                            </div>
                            <div className="col-2">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  <span className="required">Price</span>
                                </label>
                              </div>
                            </div>
                            <div className="col-2 d-flex align-items-center"></div>
                          </div>
                          {orderDetails.map((detail, index) => (
                            <div className="row" key={index}>
                              <div className="col-6">
                                <div className="fv-row mb-7 fv-plugins-icon-container">
                                  <input
                                    type="text"
                                    onChange={(e) =>
                                      setOrderDetails(
                                        orderDetails.map((d, i) =>
                                          i === index
                                            ? { ...d, item: e.target.value }
                                            : d
                                        )
                                      )
                                    }
                                    onBlur={handleBlur}
                                    value={detail.item}
                                    className="form-control form-control-solid b-1"
                                  />
                                </div>
                              </div>
                              <div className="col-2">
                                <div className="fv-row mb-7 fv-plugins-icon-container">
                                  <input
                                    type="number"
                                    step="any"
                                    onChange={(e) =>
                                      setOrderDetails(
                                        orderDetails.map((d, i) =>
                                          i === index
                                            ? { ...d, quantity: e.target.value }
                                            : d
                                        )
                                      )
                                    }
                                    onBlur={handleBlur}
                                    value={detail.quantity}
                                    className="form-control form-control-solid b-1"
                                  />
                                </div>
                              </div>
                              <div className="col-2">
                                <div className="fv-row mb-7 fv-plugins-icon-container">
                                  <input
                                    type="number"
                                    step="any"
                                    onChange={(e) =>
                                      setOrderDetails(
                                        orderDetails.map((d, i) =>
                                          i === index
                                            ? { ...d, price: e.target.value }
                                            : d
                                        )
                                      )
                                    }
                                    onBlur={() => {
                                      setOrderDetails(
                                        orderDetails.map((d, i) =>
                                          i === index
                                            ? {
                                                ...d,
                                                price: parseFloat(
                                                  d.price
                                                ).toFixed(2),
                                              }
                                            : d
                                        )
                                      );
                                    }}
                                    value={detail.price}
                                    className="form-control form-control-solid b-1"
                                  />
                                </div>
                              </div>
                              <div className="col-2 d-flex align-items-start">
                                {orderDetails.length > 1 && (
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() => removeRow(index)}
                                  >
                                    -
                                  </button>
                                )}
                                {index === orderDetails.length - 1 && (
                                  <button
                                    type="button"
                                    className="btn btn-primary ms-2"
                                    onClick={addRow}
                                  >
                                    +
                                  </button>
                                )}
                              </div>
                            </div>
                          ))}
                          <div className="row">
                            <div className="col-6">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  <span>Total Amount</span>
                                </label>
                              </div>
                            </div>
                            <div className="col-2">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  <span style={{ marginLeft: "15px" }}>
                                    {totalItem ? totalItem : ""}
                                  </span>
                                </label>
                              </div>
                            </div>
                            <div className="col-2">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  <span style={{ marginLeft: "15px" }}>
                                    {totalItemAmt
                                      ? parseFloat(totalItemAmt).toFixed(2)
                                      : ""}
                                  </span>
                                </label>
                              </div>
                            </div>
                            <div className="col-2 d-flex align-items-center"></div>
                          </div>
                          <div className="row">
                            <div className="col-4">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  <span className="required">
                                    Any Tran. Ch./Taxes (%)
                                  </span>
                                </label>
                              </div>
                            </div>
                            <div className="col-8">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <input
                                  type="number"
                                  step="any"
                                  onChange={(e) => {
                                    handleChange(e);
                                    const value = e.target.value;
                                    setTransCh(value);
                                  }}
                                  onBlur={handleBlur}
                                  name="transationCharges"
                                  id="transationCharges"
                                  value={values.transationCharges}
                                  className="form-control form-control-solid b-1"
                                />
                                {errors.transationCharges &&
                                touched.transationCharges ? (
                                  <div className="text-danger mt-2">
                                    {errors.transationCharges}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-4">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  <span>Tip Amount ($)</span>
                                </label>
                              </div>
                            </div>
                            <div className="col-8">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <input
                                  type="number"
                                  step="any"
                                  onChange={(e) => {
                                    handleChange(e);
                                    setTipAmount(e.target.value);
                                  }}
                                  onBlur={handleBlur}
                                  name="tipAmount"
                                  id="tipAmount"
                                  value={values.tipAmount}
                                  className="form-control form-control-solid b-1"
                                />
                                <div className="d-flex gap-2 mt-2">
                                  {[10, 15, 20].map((pct) => (
                                    <button
                                      key={pct}
                                      type="button"
                                      className="btn btn-sm btn-light-primary"
                                      onClick={() => {
                                        const suggested = (
                                          ((totalItemAmt || 0) * pct) /
                                          100
                                        ).toFixed(2);
                                        setFieldValue("tipAmount", suggested);
                                        setTipAmount(suggested);
                                      }}
                                    >
                                      {pct}%
                                    </button>
                                  ))}
                                </div>
                                {errors.tipAmount && touched.tipAmount ? (
                                  <div className="text-danger mt-2">
                                    {errors.tipAmount}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-4">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  <span className="required">Grand Total</span>
                                </label>
                              </div>
                            </div>
                            <div className="col-8">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <input
                                  type="number"
                                  step="any"
                                  name="total"
                                  id="total"
                                  disabled
                                  value={
                                    totalAmount === 0
                                      ? ""
                                      : parseFloat(totalAmount).toFixed(2)
                                  }
                                  className="form-control form-control-solid b-1"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-4">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  <span className="required">
                                    Payment Method
                                  </span>
                                </label>
                              </div>
                            </div>
                            <div className="col-8">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <select
                                  className="form-select form-control form-control-solid b-1"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="paymentMethod"
                                  id="paymentMethod"
                                  value={values.paymentMethod}
                                >
                                  <option value="">
                                    Select payment method
                                  </option>
                                  {paymentOptions.map((item, i) => (
                                    <option key={i} value={item.value}>
                                      {item.title}
                                    </option>
                                  ))}
                                </select>
                                {errors.paymentMethod &&
                                touched.paymentMethod ? (
                                  <div className="text-danger mt-2">
                                    {errors.paymentMethod}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-4">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  <span className="required">
                                    Payment Status
                                  </span>
                                </label>
                              </div>
                            </div>
                            <div className="col-8">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <div className="d-flex form-group form-check mb-10 align-items-center gap-2">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="isPaid"
                                    checked={values.isPaid}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  <label
                                    className="form-label fw-bolder text-dark fs-6 mb-0"
                                    htmlFor="isPaid"
                                  >
                                    Paid
                                  </label>
                                </div>
                                {errors.isPaid && touched.isPaid ? (
                                  <div className="text-danger mt-2">
                                    {errors.isPaid}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>

                          {values.isPaid && (
                            <div className="row">
                              <div className="col-4">
                                <div className="fv-row mb-7 fv-plugins-icon-container">
                                  <label className="fs-6 fw-bold form-label mt-3">
                                    <span className="required">
                                      Receipt Number
                                    </span>
                                  </label>
                                </div>
                              </div>
                              <div className="col-8">
                                <div className="fv-row mb-7 fv-plugins-icon-container">
                                  <input
                                    className="form-control form-control-solid b-1"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="receiptNumber"
                                    id="receiptNumber"
                                    value={values.receiptNumber}
                                  />
                                  {errors.receiptNumber &&
                                  touched.receiptNumber ? (
                                    <div className="text-danger mt-2">
                                      {errors.receiptNumber}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          )}

                          <div className="row">
                            <div className="col-4">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  <span className="required">
                                    Technician Assigned/Dispatched
                                  </span>
                                </label>
                              </div>
                            </div>
                            <div className="col-8">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <input
                                  className="form-control form-control-solid b-1"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="technician"
                                  id="technician"
                                  value={values.technician}
                                />
                                {errors.technician && touched.technician ? (
                                  <div className="text-danger mt-2">
                                    {errors.technician}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="row row-cols-1 row-cols-sm-1 rol-cols-md-1 row-cols-lg-1">
                            <div className="col">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  <span className="required">Any Notes</span>
                                </label>
                                <textarea
                                  rows="3"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="notes"
                                  id="notes"
                                  className="form-control form-control-solid b-1"
                                  value={values.notes}
                                ></textarea>
                              </div>
                            </div>
                          </div>
                          <div className="row row-cols-1 row-cols-sm-1 rol-cols-md-1 row-cols-lg-1">
                            <div className="col">
                              <div className="fv-row mb-7 fv-plugins-icon-container">
                                <label className="fs-6 fw-bold form-label mt-3">
                                  Customer Message / Disclaimer
                                </label>
                                <textarea
                                  rows="4"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  name="disclaimer"
                                  id="disclaimer"
                                  className="form-control form-control-solid b-1"
                                  value={values.disclaimer}
                                ></textarea>
                              </div>
                            </div>
                          </div>
                          <button type="submit" className="btn btn-primary">
                            Update Invoice
                          </button>
                        </form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

export default EditInvoice;
